import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/main.css'
import Moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import VueUeditorWrap from 'vue-ueditor-wrap'
import md5 from 'js-md5';

// Moment.locale('zh-cn');
Moment.locale('zh-cn',{
  week : {
    dow : 1,
  }
});


Vue.use(ElementUI);
Vue.use(VueClipboard);

import Config from './script/config';
import HTTPs from './script/http';
import Utils from './script/utils'
import User from './script/user';
import Api from './script/api';
import Rule from './script/rule';
import sideMenu from './script/sideMenu';
import EchartsJs from './echartScript/echartsJs';
import RegExp from './script/RegExp';

let echarts = require('echarts');

Vue.prototype.$config = Config;
Vue.prototype.$http = HTTPs;
Vue.prototype.$utils = Utils;
Vue.prototype.$api = Api;
Vue.prototype.$user = User;
Vue.prototype.$rule = Rule;
Vue.prototype.$moment = Moment;
Vue.prototype.$sideMenu = sideMenu;
Vue.prototype.$echartsJs = EchartsJs;
Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5;
Vue.prototype.$regexp = RegExp;


import Editor from './components/Editor';
import UserNavMain from './components/common/UserNavMain';
import MainLayout from './components/common/MainLayout'
import SideMenu from './components/common/SideMenu';
import TypeSelect from "@/components/widget/TypeSelect";
import YearSelect from "@/components/widget/YearSelect";
import EditButton from "@/components/button/EditButton";
import DelButton from "@/components/button/DelButton";
import AddButton from "@/components/button/AddButton";
import BaseButton from "@/components/button/BaseButton";
import MainBreadcrumb from "@/components/common/MainBreadcrumb";
import HeadImgUpload from "@/components/widget/HeadImgUpload";
import PushTime from "@/components/widget/PushTime";
import CompanySelect from "@/components/widget/CompanySelect";
import FileUpload from "@/components/widget/FileUpload";
import AreaSelect from "@/components/widget/AreaSelect";
import SortSelect from "@/components/widget/SortSelect";
import IconDialog from "@/components/dialog/IconDialog";
import ZdSelect from "@/components/widget/ZdSelect";
import OneCheckBox from "@/components/widget/OneCheckBox";
import PriceTimeSelect from "@/components/widget/PriceTimeSelect";
import OrderTypeSelect from "@/components/widget/OrderTypeSelect";
import OrderStateSelect from "@/components/widget/OrderStateSelect";
import ColorSelect from "@/components/widget/ColorSelect";
import ProvinceSelect from "@/components/widget/ProvinceSelect";
import RangeTime from "@/components/widget/RangeTime";
import GroupSelect from "@/components/widget/GroupSelect";
import CreateTime from "@/components/widget/CreateTime";
import UEditor from "@/components/UEditor";
import BarEcharts from "@/components/common/BarEcharts";
import TimePicker from './components/widget/TimePicker'

Vue.component("edit-button", EditButton);
Vue.component("del-button", DelButton);
Vue.component("add-button", AddButton);
Vue.component("base-button", BaseButton);
Vue.component("editor", Editor);
Vue.component('lee-bar-echarts', BarEcharts);
Vue.component('m-main-layout',MainLayout);
Vue.component('m-side-menu',SideMenu);
Vue.component('m-user-nav-main',UserNavMain);
Vue.component('editor',Editor);
Vue.component('type-select',TypeSelect);
Vue.component('company-select',CompanySelect);
Vue.component('year-select',YearSelect);
Vue.component('m-breadcrumb',MainBreadcrumb);
Vue.component('head-img-upload',HeadImgUpload);
Vue.component('push-time',PushTime);
Vue.component('file-upload',FileUpload);
Vue.component('area-select',AreaSelect);
Vue.component('sort-select',SortSelect);
Vue.component('zd-select',ZdSelect);
Vue.component('one-checkbox',OneCheckBox);
Vue.component('icon-dialog',IconDialog);
Vue.component('price-time-select',PriceTimeSelect);
Vue.component('order-type-select',OrderTypeSelect);
Vue.component('order-state-select',OrderStateSelect);
Vue.component('color-select',ColorSelect);
Vue.component('province-select',ProvinceSelect);
Vue.component('range-time',RangeTime);
Vue.component('group-select',GroupSelect);
Vue.component('create-time',CreateTime);
Vue.component('UEditor',UEditor);
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.component('time-picker', TimePicker)

router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log('from:'+from.path);

  // if(from.path === '/'){
  //   let _routes = Rule.getRoutes();
  //
  //   if(_routes) {
  //     new Promise((resolve,reject)=>{
  //       router.onReady(()=>{
  //         router.addRoutes(_routes);
  //         resolve(next());
  //       });
  //     });
  //   }
  // }

  // console.log(from.path);
  //
  // if(to.path === '/'){
  //   next({ path: '/home' });
  // }
  /* must call `next` */
  let _crossList = ['/login'];
  if(_crossList.indexOf(to.path) === -1){
    if(!User.getToken()){
      next({ path: '/login' })
    }else{
      next();
    }
  }else{
    next();
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
